goog.provide('el8.ptdata.ptRefpanelGrant');

goog.require('el8.model.base');

el8.ptdata.ptRefpanelGrant = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.addEvents();

    _class.addIntProperty('grantLevel');

    var that = new _class({});
    that.load = function() {
        $.el8_ajax({
            url: el8.service.urls.get('patientLhsSettings'),
            type: 'GET',
            async: false,
            success: function(value) {
                that.setGrantLevel(value);
            }
        });
    };
    that.softLoad = function() {
        if (_.isNumber(that.getGrantLevel())) { return; }
        that.load();
    };

    // when the grant level changes, the letter pane will need to update
    var super_setGrantLevel = that.setGrantLevel;
    that.setGrantLevel = function(value) {
        super_setGrantLevel.call(that, value);
        that.trigger(EVENTS.UPDATED);
    };

    return that;

})();

